"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _logError = _interopRequireDefault(require("./logError"));

/**
 * Log the error passed to a catch() handler of an axios Promise
 *
 * Will extract relevant information from the error as best as we can and then
 * log the appropriate parts.
 *
 * These suggestions are pulled from the Axios docs, we should improve them
 * as we find that we need more context!
 *
 * @param {Object.<Error>|string} error - The argument passed to the catch() handler of an axios Promise.
 */
var logAxiosError = function logAxiosError(error) {
  if (error.response) {
    // non-2XX response code
    var fingerprint = [error.response.status, error.request.responseURL];
    error.message = "".concat(error.message, " - ").concat(error.response.status, " - ").concat(error.request.responseURL);
    (0, _logError.default)(error, {
      data: error.response.data,
      status: error.response.status,
      headers: error.response.headers
    }, fingerprint);
  } else {
    // Some other type of error
    (0, _logError.default)(error, {
      message: error.message
    });
  }
};

var _default = logAxiosError;
exports.default = _default;